module.exports = __webpack_public_path__ + "static/media/remove-pin-char.6be3446a.svg";